import { ObserversModule } from '@angular/cdk/observers';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatErrorDirective, MatHintDirective, MatLabelDirective, MatSuffixDirective } from './directives';
import { MatFormFieldComponent } from './form-field.component';

@NgModule({
  declarations: [MatErrorDirective, MatFormFieldComponent, MatHintDirective, MatLabelDirective, MatSuffixDirective],
  exports: [MatErrorDirective, MatFormFieldComponent, MatHintDirective, MatLabelDirective, MatSuffixDirective],
  imports: [CommonModule, ObserversModule],
})
export class FormFieldModule {}
